<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" icon="el-icon-plus" @click="add">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      :allBtnWidth="allBtnWidth" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template slot="isdisplay" slot-scope="params">
        <MySwitch :data="params.params" :activeValue="'1'" :inactiveValue="`2`" @onToggle="toggleDisplay"></MySwitch>
      </template>
    </Table>

    <FormDialog ref="dialog" :title="title" :width="'548px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'cargoconfiguration',
      breadcrumb: [
        { name: "系统设置" },
        { name: "货物配置" },
      ],
      formCtrl: [
        {
          label: "",
          keyName: "name",
          placeholder: "请填写货物名称",
          type: "text",
        },
        
      ],
      cols: [
        { keyName: "name", label: "货物名称" },
        { keyName: "sort", label: "排序" },
        { keyName: "isdisplay", label: "是否显示", slot: 'isdisplay' },
        { keyName: "user_name", label: "创建人" },
        { keyName: "created_at", label: "创建时间" },
      ],
      allBtnWidth: '100px',
      btns: [
        {
          ...this.editBtn,
          cb: (data) => {
            // console.log(data)
            this.getItem(data)
            this.showDialog()
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
      title: '添加',
      viewMode: false,
      mform: { name: undefined },
      mrules: {
        name: [
          {
            required: true,
            message: '请填写货物名称',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          label: "货物名称",
          keyName: "name",
          err: "请填写货物名称",
          type: "text",
        },
        {
          label: "排序",
          keyName: "sort",
          err: "请填写排序",
          type: "number",
          unit: "数字越大排序越靠前",
        },
        {
          label: "是否显示",
          keyName: "isdisplay",
          type: "radio",
          options: [
            { label: '是', value: 1 },
            { label: '否', value: 2 },
          ],
        },
      ],
      canNotHide: [1, 2, 3, 4, 5],
      canNotEdit: [1, 2, 3, 4, 5],
    };
  },
  methods: {
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const obj = this.dataObjHandler(v)
          obj.open = v.isdisplay + ''
          // obj.DISABLED = this.canNotEdit.includes(obj.id)
          if (this.canNotEdit.includes(obj.id)) {
            // obj.DISABLED = true
            obj.addtime = '-'
          }
          // console.log({...obj})
          return obj
        })
      }
      // console.log(this.tableData)
    },
    toggleDisplay({ id }) {
      console.log(id)
      let url = `${this.baseUrl}/upstatus `;
      const params = {
        // userid: this.user.id,
        id,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '修改成功!',
          });
          this.getList(true)
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    add() {
      delete this.mform.id
      this.mform = { name: undefined, isdisplay: 1 }
      this.title = '添加'
      this.showDialog()
    },
    getItem({ id, name,isdisplay,sort }) {
      this.mform = { ...this.mform, id, name,isdisplay,sort }
      this.title = '修改'
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .dialog {
  .el-form {
    padding-right: 0 !important;

    .el-form-item .el-form-item__content .content {
      display: block;

      .unit {
        line-height: 30px;
        margin: 0 auto;
        font-size: 12px;
        color: #FF6756;
      }
    }

    .el-input {
      width: 230px;
    }
  }

  .btns .mians {
    text-align: center;
  }
}
</style>
